/// KeyboardEvent.key values. Duck defaults to Space, jump to ArrowUp.

export const defaultJumpKey = 'ArrowUp';
export const defaultDuckKey = ' ';

export interface KeyboardBindings {
  jump: string;
  duck: string;
}

export const defaultKeyboardBindings: KeyboardBindings = {
  jump: defaultJumpKey,
  duck: defaultDuckKey,
};

export function normalizeKey(key: string): string {
  if (key === 'Spacebar' || key === 'Space') return ' ';
  return key;
}

export function keysEqual(a: string, b: string): boolean {
  return normalizeKey(a) === normalizeKey(b);
}

const blocked = new Set([
  'Tab',
  'Escape',
  'Meta',
  'Control',
  'Alt',
  'Shift',
  'Dead',
  'Compose',
  'Process',
  'Unidentified',
  'ContextMenu',
]);

export function isBindableKey(key: string): boolean {
  const value = normalizeKey(key);
  if (value.length === 0) return false;
  if (blocked.has(value)) return false;
  if (/^F\d{1,2}$/.test(value)) return false;
  return true;
}

/** Short label for a KeyboardEvent.key. Space / arrows stay readable. */
export function formatKeyLabel(key: string): string {
  switch (normalizeKey(key)) {
    case ' ':
      return 'Space';
    case 'ArrowUp':
      return 'Up';
    case 'ArrowDown':
      return 'Down';
    case 'ArrowLeft':
      return 'Left';
    case 'ArrowRight':
      return 'Right';
    default: {
      const value = normalizeKey(key);
      return value.length === 1 ? value.toUpperCase() : value;
    }
  }
}
